import React from 'react'
import {
  ChakraProvider,
  Box,
  Center,
  Text,
  Button,
  Card,
  Image,
  Flex,
} from '@chakra-ui/react'

const AfrotopiaProjectScreen = () => {
  const projectDetails = ['/afrotopia.png']

  const projectStack = [
    {
      stackImgSrc: 'fa-brands fa-react',
      stackName: 'Reactjs',
    },
    {
      stackImgSrc: 'fa-brands fa-css3-alt',
      stackName: 'CSS',
    },
    {
      stackImgSrc: 'fa-solid fa-database',
      stackName: 'MongoDB',
    },
    {
      stackImgSrc: 'fa-brands fa-node',
      stackName: 'Expressjs',
    },
  ]
  return (
    <ChakraProvider>
      <Box
        w={{
          base: '90%',
          sm: '90%',
          md: '90%',
          lg: '90%',
          xl: '90%',
        }}
        alignContent='center'
        mx='auto'
        h={{
          base: 'auto',
          sm: 'auto',
          md: 'auto',
          lg: 'auto',
          xl: 'auto',
        }}>
        <Center>
          <Text
            fontSize={{
              base: '30px',
              sm: '30px',
              md: '35px',
              lg: '35px',
              xl: '35px',
            }}
            fontFamily='Inter'
            letterSpacing='5px'
            my='50px'>
            {' '}
            Afrotopia
          </Text>
        </Center>
        <Center>
          <Flex
            textAlign='center'
            direction={{
              base: 'column',
              sm: 'column',
              md: 'column',
              lg: 'column',
              xl: 'column',
            }}
            gap='30px'
            w='auto'>
            {projectDetails.map((projectDetail, index) => (
              <Card maxW='sm' key={index} textAlign='center'>
                <Image src={projectDetail} textAlign='center' />
              </Card>
            ))}
          </Flex>
        </Center>
        <Center>
          <Text
            fontSize={{
              base: '30px',
              sm: '30px',
              md: '35px',
              lg: '35px',
              xl: '35px',
            }}
            fontFamily='Inter'
            letterSpacing='5px'
            mt='50px'>
            {' '}
            About Afrotopia
          </Text>
        </Center>
        <Center>
          <Text fontFamily='Roboto mono' letterSpacing='5px' my='30px'>
            Afrotopia is a fashion store site that allows registered users
            purchase their choice fits for exclusive occasions! Users are able
            to pick from a range of trendy outfits exhibited by fashion icons
            from all over the globe!
          </Text>
        </Center>
        <Center>
          <Text
            fontSize={{
              base: '35px',
              sm: '35px',
              md: '25px',
              lg: '25px',
              xl: '25px',
            }}
            fontFamily='Inter'
            letterSpacing='5px'
            my='50px'>
            {' '}
            Stack
          </Text>
        </Center>
        <Center>
          <Flex
            textAlign='center'
            direction={{
              base: 'column',
              sm: 'column',
              md: 'row',
              lg: 'row',
              xl: 'row',
            }}
            gap='30px'
            w='auto'>
            {projectStack.map((projectDetail, index) => (
              <Box maxW='sm' key={index} textAlign='center'>
                <i class={projectDetail.stackImgSrc}></i>{' '}
                {projectDetail.stackName}
              </Box>
            ))}
          </Flex>
        </Center>
      </Box>
    </ChakraProvider>
  )
}

export default AfrotopiaProjectScreen
